/** Démarre un glisser horizontal générique (barre latérale, colonnes de tableau...). `onDelta` reçoit le déplacement en pixels depuis le dernier événement, pas depuis le point de départ. */
export function startHorizontalResize(startClientX: number, onDelta: (deltaPx: number) => void) {
  let lastX = startClientX;
  const onMove = (e: MouseEvent) => {
    const delta = e.clientX - lastX;
    lastX = e.clientX;
    onDelta(delta);
  };
  const onUp = () => {
    window.removeEventListener('mousemove', onMove);
    window.removeEventListener('mouseup', onUp);
  };
  window.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
